<template>
  <div>
    <div class="container-fluid px-0 overflow-hidden">
      <img src="../assets/sushicase.jpg" alt="" style="width: 100%" />
      <div class="carousel-caption d-none d-md-block" style="height:200px">
        <h5>Nuestro Menú</h5>
      </div>
    </div>
    <!-- <div class="container" style="z-index: 999">
      <div class="row">
        <div class="col-3 py-2">
          <a href="#promociones">Promociones</a>
        </div>
      </div>
    </div> -->

    <div class="container">
      <div class="row" ref="promociones">
        <div class="col">
          <h1 class="text-center">Promociones</h1>

          <div class="row">
            <div class="col">
              <div
                class="cmsmasters_menu_item menu_best"
                v-for="(promo, i) in promociones"
                :key="i"
              >
                <div class="cmsmasters_menu_item_inner">
                  <div class="menu_title_wrap">
                    <h4 class="menu_title">{{ promo.title }}</h4>
                    <h6 class="cmsmasters_menu_price" v-if="promo.prize">
                      ${{ promo.prize }}
                    </h6>
                  </div>
                  <div
                    class="cmsmasters_menu_best_feature"
                    v-if="promo.featured"
                  >
                    {{ promo.featured }}
                  </div>
                  <div class="w-100"></div>
                  <div class="menu_feature_list_wrap">
                    <strong v-if="promo.info" class="text-danger ml-1" style="white-space: pre;">{{
                      promo.info
                    }}</strong>
                    <ul class="menu_feature_list">
                      <li v-for="(detail, i) in promo.details" :key="i">
                        {{ detail }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" ref="handrolls">
        <div class="col">
          <h1 class="text-center">Handrolls</h1>

          <div class="row">
            <div class="col">
              <div
                class="cmsmasters_menu_item menu_best"
                v-for="(promo, i) in handrolls"
                :key="i"
              >
                <div class="cmsmasters_menu_item_inner">
                  <div class="menu_title_wrap">
                    <h4 class="menu_title">{{ promo.title }}</h4>
                    <h6 class="cmsmasters_menu_price" v-if="promo.prize">
                      ${{ promo.prize }}
                    </h6>
                  </div>
                  <div
                    class="cmsmasters_menu_best_feature"
                    v-if="promo.featured"
                  >
                    {{ promo.featured }}
                  </div>
                  <div class="menu_feature_list_wrap">
                    <strong v-if="promo.info" class="text-danger ml-1">{{
                      promo.info
                    }}</strong>
                    <ul class="menu_feature_list">
                      <li v-for="(detail, i) in promo.details" :key="i">
                        {{ detail }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col" style="margin: 40px 0">
          <img src="../assets/images/para_compartir.jpg" style="width: 100%" />
        </div>
      </div>

      <div class="row" ref="compartir">
        <div class="col">
          <h1 class="text-center">Para compartir</h1>

          <div class="row">
            <div class="col">
              <div
                class="cmsmasters_menu_item menu_best"
                v-for="(promo, i) in compartir"
                :key="i"
              >
                <div class="cmsmasters_menu_item_inner">
                  <div class="menu_title_wrap">
                    <h4 class="menu_title">{{ promo.title }}</h4>
                    <h6 class="cmsmasters_menu_price">${{ promo.prize }}</h6>
                  </div>
                  <div
                    class="cmsmasters_menu_best_feature"
                    v-if="promo.featured"
                  >
                    {{ promo.featured }}
                  </div>
                  <div class="menu_feature_list_wrap">
                    <ul class="menu_feature_list">
                      <li v-for="(detail, i) in promo.details" :key="i">
                        {{ detail }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" ref="ceviches">
        <div class="col d-none" style="margin: 40px 0">
          <img
            src="../assets/images/ceviche.jpg"
            style="width: 100%; filter: brightness(1.4)"
          />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <h1 class="text-center" id="ceviche">Ceviches</h1>

          <div class="row">
            <div class="col">
              <div
                class="cmsmasters_menu_item menu_best"
                v-for="(promo, i) in ceviches"
                :key="i"
              >
                <div class="cmsmasters_menu_item_inner">
                  <div class="menu_title_wrap">
                    <h4 class="menu_title">{{ promo.title }}</h4>
                    <h6 class="cmsmasters_menu_price">${{ promo.prize }}</h6>
                  </div>
                  <div
                    class="cmsmasters_menu_best_feature"
                    v-if="promo.featured"
                  >
                    {{ promo.featured }}
                  </div>
                  <div class="menu_feature_list_wrap">
                    <ul class="menu_feature_list">
                      <li v-for="(detail, i) in promo.details" :key="i">
                        {{ detail }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="false">
        <div class="col">
          <h1 class="text-center">Para beber</h1>

          <div class="row">
            <div class="col">
              <div
                class="cmsmasters_menu_item menu_best"
                v-for="(promo, i) in para_beber"
                :key="i"
              >
                <div class="cmsmasters_menu_item_inner">
                  <div class="menu_title_wrap">
                    <h4 class="menu_title">{{ promo.title }}</h4>
                    <h6 class="cmsmasters_menu_price">${{ promo.prize }}</h6>
                  </div>
                  <div
                    class="cmsmasters_menu_best_feature"
                    v-if="promo.featured"
                  >
                    {{ promo.featured }}
                  </div>
                  <div class="menu_feature_list_wrap">
                    <ul class="menu_feature_list">
                      <li v-for="(detail, i) in promo.details" :key="i">
                        {{ detail }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="false">
        <div class="col">
          <h1 class="text-center">Cervezas</h1>

          <div class="row">
            <div class="col">
              <div
                class="cmsmasters_menu_item menu_best"
                v-for="(promo, i) in cervezas"
                :key="i"
              >
                <div class="cmsmasters_menu_item_inner">
                  <div class="menu_title_wrap">
                    <h4 class="menu_title">{{ promo.title }}</h4>
                    <h6 class="cmsmasters_menu_price">${{ promo.prize }}</h6>
                  </div>
                  <div
                    class="cmsmasters_menu_best_feature"
                    v-if="promo.featured"
                  >
                    {{ promo.featured }}
                  </div>
                  <div class="menu_feature_list_wrap">
                    <ul class="menu_feature_list">
                      <li v-for="(detail, i) in promo.details" :key="i">
                        {{ detail }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col" style="margin: 40px 0">
          <img src="../assets/images/nigiris.jpg" style="width: 100%" />
        </div>
      </div>

      <div class="row" ref="gohan_y_ramen">
        <div class="col">
          <h1 class="text-center">Bowls</h1>

          <div class="row">
            <div class="col">
              <div
                class="cmsmasters_menu_item menu_best"
                v-for="(promo, i) in gohan_y_ramen"
                :key="i"
              >
                <div class="cmsmasters_menu_item_inner">
                  <div class="menu_title_wrap">
                    <h4 class="menu_title">{{ promo.title }}</h4>
                    <h6 class="cmsmasters_menu_price">${{ promo.prize }}</h6>
                  </div>
                  <div
                    class="cmsmasters_menu_best_feature"
                    v-if="promo.featured"
                  >
                    {{ promo.featured }}
                  </div>
                  <div class="menu_feature_list_wrap">
                    <ul class="menu_feature_list">
                      <li v-for="(detail, i) in promo.details" :key="i">
                        {{ detail }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col" style="margin: 40px 0">
          <img src="../assets/images/roll.jpg" style="width: 100%" />
        </div>
      </div>

      <div class="row" ref="sin_arroz">
        <div class="col-12 col-md">
          <h1 class="text-center mb-2">Rolls Sin Arroz</h1>
          <small class="d-block text-center text-danger font-weight-bold"
            >Todos incluyen Queso crema</small
          >
          <small class="d-block text-center">*No incluyen en 4x3</small>
          <div class="row mt-2">
            <div class="col">
              <div
                class="cmsmasters_menu_item menu_best"
                v-for="(promo, i) in roll_sin_arroz"
                :key="i"
              >
                <div class="cmsmasters_menu_item_inner">
                  <div class="menu_title_wrap">
                    <h4 class="menu_title">{{ promo.title }}</h4>
                    <h6 class="cmsmasters_menu_price">${{ promo.prize }}</h6>
                  </div>
                  <div
                    class="cmsmasters_menu_best_feature"
                    v-if="promo.featured"
                  >
                    {{ promo.featured }}
                  </div>
                  <div class="menu_feature_list_wrap">
                    <ul class="menu_feature_list">
                      <li v-for="(detail, i) in promo.details" :key="i">
                        {{ detail }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" ref="arma_tu_roll">
        <div class="col-12">
          <h1 class="text-center">Arma tu roll</h1>
          <p class="text-center">
            Elige la cobertura, luego una proteina tradicional o premium ($1.000
            adicional) y dos acompañamientos para armar tu Roll de 8 piezas
          </p>
          <p class="text-center">Veggie o vegano elige 3 acompañamientos</p>
        </div>
        <div class="col-12 col-md">
          <h2 class="text-center">Coberturas Frías</h2>

          <div class="row">
            <div class="col">
              <div
                class="cmsmasters_menu_item menu_best"
                v-for="(promo, i) in arma_tu_roll_frios"
                :key="i"
              >
                <div class="cmsmasters_menu_item_inner">
                  <div class="menu_title_wrap">
                    <h4 class="menu_title">{{ promo.title }}</h4>
                    <h6 class="cmsmasters_menu_price">${{ promo.prize }}</h6>
                  </div>
                  <div
                    class="cmsmasters_menu_best_feature"
                    v-if="promo.featured"
                  >
                    {{ promo.featured }}
                  </div>
                  <div class="menu_feature_list_wrap">
                    <ul class="menu_feature_list">
                      <li v-for="(detail, i) in promo.details" :key="i">
                        {{ detail }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md" ref="arma_tu_roll_fritos">
          <h2 class="text-center">Coberturas Fritas</h2>
          <div class="row">
            <div class="col">
              <div
                class="cmsmasters_menu_item menu_best"
                v-for="(promo, i) in arma_tu_roll_fritos"
                :key="i"
              >
                <div class="cmsmasters_menu_item_inner">
                  <div class="menu_title_wrap">
                    <h4 class="menu_title">{{ promo.title }}</h4>
                    <h6 class="cmsmasters_menu_price">${{ promo.prize }}</h6>
                  </div>
                  <div
                    class="cmsmasters_menu_best_feature"
                    v-if="promo.featured"
                  >
                    {{ promo.featured }}
                  </div>
                  <div class="menu_feature_list_wrap">
                    <ul class="menu_feature_list">
                      <li v-for="(detail, i) in promo.details" :key="i">
                        {{ detail }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row opciones">
        <div class="col-12 col-md col-lg-6">
          <span class="red">Proteinas tradicionales:</span>
          <small class="text-muted d-block text-uppercase"
            >1 ingrediente por roll</small
          >
          <p class="text-justify">
            Camarón, Camarón Tempura, Camarón Panko, Pollo Teriyaki, Pollo
            Panko, Kanikama, Salmón, Salmón Tempura, Salmón Panko, Machas.
          </p>
        </div>
        <div class="col-12 col-md-12 col-lg-6">
          <span class="red">Acompañamientos para proteina</span>
          <small class="text-muted d-block text-uppercase"
            >2 ingredientes por roll</small
          >
          <p class="text-justify">
            Alcachofas, Ají verde, Choclo, Palmitos, Palta, Espárragos,
            Champiñón , Ciboulette, Pepino, Pimentón, Frutillas, Cebollín,
            Tomate Cherry, Aceitunas, Queso Crema, Queso Mantecoso, Queso Tofu
            (vegano).
          </p>
        </div>
        <div class="col-12 col-md">
          <span class="red">Proteinas Premium:</span>
          <small class="text-muted d-block text-uppercase">
            $1.000 adicional cada una
          </small>
          <p class="text-justify">
            Carne de res, Jaiba, Ostión, Ostion Furai, Pulpo, Salmón Ahumado,
            Atún rojo.
          </p>
        </div>

        <div class="w-100 py-3"></div>

        <div class="col-12">
          <h1 class="text-center mb-4">Extras</h1>
        </div>

        <div class="col-12 col-md-6">
          <div class="cmsmasters_menu_item menu_best">
            <div class="cmsmasters_menu_item_inner">
              <div class="menu_title_wrap">
                <h4 class="menu_title">Cambio o Extra Adicional</h4>
                <h6 class="cmsmasters_menu_price">$1.000</h6>
              </div>
            </div>
            <div class="cmsmasters_menu_item_inner">
              <div class="menu_title_wrap">
                <h4 class="menu_title">Extra Salsa de Soya o Agridulce</h4>
                <h6 class="cmsmasters_menu_price">$500</h6>
              </div>
            </div>
            <div class="cmsmasters_menu_item_inner">
              <div class="menu_title_wrap">
                <h4 class="menu_title">Chopstick (Ayuda palitos)</h4>
                <h6 class="cmsmasters_menu_price">$200</h6>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="cmsmasters_menu_item menu_best">
            <div class="cmsmasters_menu_item_inner">
              <div class="menu_title_wrap">
                <h4 class="menu_title">Salsa de Vino Tinto</h4>
                <h6 class="cmsmasters_menu_price">$500</h6>
              </div>
            </div>
            <div class="cmsmasters_menu_item_inner">
              <div class="menu_title_wrap">
                <h4 class="menu_title">Salsa Cesar</h4>
                <h6 class="cmsmasters_menu_price">$500</h6>
              </div>
            </div>
            <div class="cmsmasters_menu_item_inner">
              <div class="menu_title_wrap">
                <h4 class="menu_title">Salsa de Ajo con Ciboulette</h4>
                <h6 class="cmsmasters_menu_price">$500</h6>
              </div>
            </div>
            <div class="cmsmasters_menu_item_inner">
              <div class="menu_title_wrap">
                <h4 class="menu_title">Salsa Niku (Salsa de Carne)</h4>
                <h6 class="cmsmasters_menu_price">$500</h6>
              </div>
            </div>
            <div class="cmsmasters_menu_item_inner">
              <div class="menu_title_wrap">
                <h4 class="menu_title">
                  Salsa Tonkatsu (Salsa de verduras agridulce)
                </h4>
                <h6 class="cmsmasters_menu_price">$500</h6>
              </div>
            </div>
            <div class="cmsmasters_menu_item_inner">
              <div class="menu_title_wrap">
                <h4 class="menu_title">Salsa Sriracha (Ají japonés)</h4>
                <h6 class="cmsmasters_menu_price">$500</h6>
              </div>
            </div>
            <div class="cmsmasters_menu_item_inner">
              <div class="menu_title_wrap">
                <h4 class="menu_title">Salsa Maracuyá</h4>
                <h6 class="cmsmasters_menu_price">$500</h6>
              </div>
            </div>
            <div class="cmsmasters_menu_item_inner">
              <div class="menu_title_wrap">
                <h4 class="menu_title">Salsa Sweet Chilli</h4>
                <h6 class="cmsmasters_menu_price">$500</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" ref="coberturas_exclusivas">
        <div class="col-12 col-md-12">
          <h1 class="text-center mb-2">Coberturas Exclusivas</h1>
          <span class="d-block text-center text-uppercase"
            >*No valida para promoción 4x3</span
          >
          <div class="row">
            <div class="col">
              <div
                class="cmsmasters_menu_item menu_best"
                v-for="(promo, i) in coberturas_exclusivas"
                :key="i"
              >
                <div class="cmsmasters_menu_item_inner">
                  <div class="menu_title_wrap">
                    <h4 class="menu_title">{{ promo.title }}</h4>
                    <h6 class="cmsmasters_menu_price">${{ promo.prize }}</h6>
                  </div>
                  <div
                    class="cmsmasters_menu_best_feature"
                    v-if="promo.featured"
                  >
                    {{ promo.featured }}
                  </div>
                  <div class="menu_feature_list_wrap">
                    <ul class="menu_feature_list">
                      <li v-for="(detail, i) in promo.details" :key="i">
                        {{ detail }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goto(id) {
      this.$refs[id].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    },
    getClean(str) {
      return str.replace(/\s|_/g, ' ')
    },
  },
  computed: {
    categories() {
      console.log(this._data);
      return Object.keys(this._data);
    },
  },
  watch: {
    $route(to, from) {
      console.log('change')
      if (to.hash) {
        this.goto(to.hash.replace('#', ''));
      }
    },
  },
  data() {
    return {
      promociones: [
        {
          title: "Eien Promo #1 (26 piezas)",
          info: "Rellenos a elección del chef.\nIncluye palitos y 3 salsas a elección",
          image: "../promos/IMG_0021.jpg",
          prize: "12.990",
          details: [
            "8 piezas Panko o tempura roll",
            "8 piezas Avocado o california roll",
            "8 piezas Hosomaki roll",
            "2 Nigiris",
          ],
        },
        {
          title: "Eien Promo #2 (44 piezas)",
          info: "Rellenos a elección del chef\nIncluye palitos y 4 salsas a elección",
          prize: "15.990",
          details: [
            "8 piezas Panko roll",
            "8 piezas Tempura roll",
            "8 piezas Avocado o sake roll",
            "8 piezas California roll",
            "8 piezas Hosomaki tempura roll",
            "4 Gyosas",
          ],
        },
        {
          title: "Eien Promo #3 (56 piezas)",
          prize: "18.990",
          info: "Rellenos a elección del chef\nIncluye palitos y 6 salsas a elección",
          details: [
            "8 piezas Panko roll",
            "8 piezas Tempura roll",
            "8 piezas Avocado o sake roll",
            "8 piezas California roll",
            "8 piezas Snow roll",
            "8 piezas Hosomaki tempura roll",
            "8 Gyosas",
          ],
        },
        {
          title: "Eien Promo #4 (32 piezas)",
          prize: "15.990",
          info: "Incluye palitos y 4 salsas a elección",
          featured: "PROMO EXCLUSIVA",
          details: [
            "8 piezas Panko roll (Carne, Queso Crema y Champiñón)",
            "8 piezas Ceviche roll (Camarón, Queso Crema y Cebollín)",
            "8 piezas Super snow roll (Pollo Panko, Palta y Pepino)",
            "8 piezas Spicy roll (Machas, Queso Crema y Pimentón)",
          ],
        },
        {
          title: "Eien Promo #5 (80 piezas)",
          info: "Rellenos a elección del chef\nIncluye palitos y 10 salsas a elección",
          featured: "NUEVO",
          prize: "29.990",
          details: [
            "16 piezas Panko roll ",
            "8 piezas Tempura roll",
            "8 piezas Avocado roll",
            "8 piezas Sake roll",
            "8 piezas Snow roll",
            "8 piezas California roll",
            "8 piezas California Green roll",
            "8 piezas Hosomaki roll",
            "8 piezas Hosomaki Tempura roll",
          ],
        },
        {
          title: "Eien Promo #6 (50 piezas hot)",
          featured: "NUEVO",
          info: "Relleno a elección del cliente\nIncluye palitos y 6 salsas a elección",
          prize: "19.990",
          details: [
            "32 piezas Panko roll",
            "8 piezas Hosomaki Panko roll",
            "10 arrollados primavera",
          ],
        },
        {
          title: "Eien Promo #7 (50 piezas veggie o vegan)",
          featured: "NUEVO",
          info: "Incluye palitos y 6 salsas a elección",
          prize: "18.990",
          details: [
            "32 piezas con cobertura y relleno a elección vegetariana/vegana",
            "8 piezas Hosomaki roll y relleno a elección vegetariana/vegana",
            "10 Gyosas veganas",
          ],
        },
        {
          title: "Eien Promo 4x3 (32 piezas)",
          info: "¡ Elige 4 y paga solo 3 ! (No se incluyen coberturas exclusivas, ni rolls sin arroz)\nIncluye palitos y 4 salsas a elección",
          prize: "",
          details: [
            "Elige las coberturas y rellenos de 4 rolls",
            "El valor de la promoción dependera de las coberturas selecciónadas",
          ],
        },
      ],
      compartir: [
        {
          title: "Nigiris 2 unidades",
          prize: "2.500",
          details: ["Salmón, Camarón o Pulpo."],
        },
        {
          title: "Gyosas 8 unidades",
          prize: "6.000",
          details: ["Pollo, Cerdo, Camarón-queso, Vegetarianas, Carne."],
        },
        {
          title: "Arrollados Primavera 10 unidades",
          prize: "4.000",
          details: ["Mix de vegetales."],
        },
        // {
        //   title: 'Coroke (Salmón) 8 unidades',
        //   prize: '3.500'
        // },
        {
          title: "Ebi Tempura 9 unidades",
          prize: "7.000",
          details: ["Camarón Rebozado"],
        },
        {
          title: "Ebi Furai 9 unidades",
          prize: "7.000",
          details: ["Camarón Apanado"],
        },
        {
          title: "Ika Furai (10 unidades)",
          prize: "6.500",
          details: ["Calamar Apanado"],
        },
        {
          title: "Sashimi Salmón 9 unidades",
          prize: "8.500",
        },
        {
          title: "Sashimi Pulpo 9 unidades",
          prize: "9.500",
        },
        {
          title: "Sashimi Mixto 15 unidades",
          prize: "11.500",
        },
        {
          title: "Ebi al ajillo 16 unidades",
          prize: "8.200",
          details: ["Camarón salteado en ajo"],
        },
        {
          title: "Ebi al pil-pil 16 unidades",
          prize: "8.200",
          details: ["Camarón, ají cacho de cabra"],
        },
        // {
        //   title: 'Ebi rockefort 16 unidades',
        //   prize: '8.700',
        //   details: ['Camarón salteado en 2 quesos']
        // },
        // {
        //   title: 'Ebi Gohan 16 unidades',
        //   prize: '8.200',
        //   details: ['Camarón bridado en tocino con salsa teriyaki']
        // },
        {
          title: "Hosomaki (8 piezas) con 3 rellenos a elección",
          prize: "3.500",
          details: ["Extra de panko o tempura $500 adicional"],
        },
      ],
      ceviches: [
        {
          title: "Ceviche de Machas",
          prize: "8.500",
          details: [
            "Machas, Mix de pimientos, cebollín, cebolla morada, choclo tradicional, palta y leche de tigre.",
          ],
        },
        {
          title: "Ceviche Simple",
          prize: "9.500",
          details: [
            "Salmón, mix de pimientos, cebollín, cebolla morada, choclo tradicional, palta y leche de tigre.",
          ],
        },
        {
          title: "Ceviche Mixto ",
          prize: "10.500",
          details: [
            "Salmón, Camarón, mix de pimientos, cebollín, cebolla morada, choclo tradicional, palta y leche de tigre.",
          ],
        },
        {
          title: "Ceviche del Chef",
          prize: "11.500",
          details: [
            "Salmón, Camarón, Jaiba, mix de pimientos, palta, cebollín, cebolla morada, choclo tradicional y leche de tigre.",
          ],
        },
      ],
      // para_beber: [
      //   {
      //     title: "Bebidas variedades",
      //     prize: "1.100",
      //   },
      //   {
      //     title: "Jugos naturales",
      //     prize: "1.400",
      //   },
      //   {
      //     title: "Té Dilmah variedades",
      //     prize: "1.000",
      //   },
      //   {
      //     title: "Café",
      //     prize: "800",
      //   },
      // ],
      // cervezas: [
      //   {
      //     title: "Royal Guard",
      //     prize: "2.200",
      //   },
      //   {
      //     title: "Sol",
      //     prize: "2.200",
      //   },
      //   {
      //     title: "Heineken",
      //     prize: "2.200",
      //   },
      //   {
      //     title: "Heineken sin Alcohol ",
      //     prize: "2.200",
      //   },
      //   {
      //     title: "Coors",
      //     prize: "2.200",
      //   },
      //   {
      //     title: "Stella Artois ",
      //     prize: "2.200",
      //   },
      //   {
      //     title: "Cusqueña",
      //     prize: "2.400",
      //   },
      //   {
      //     title: "Austral Calafate",
      //     prize: "2.600",
      //   },
      //   {
      //     title: "Kunstmann Torobayo",
      //     prize: "2.600",
      //   },
      //   {
      //     title: "Michelada",
      //     prize: "500",
      //     details: ["Valor adicional a la cerveza elegida"],
      //   },
      // ],
      arma_tu_roll_frios: [
        {
          title: "Futomaki Roll",
          prize: "4.400",
          details: ["Cubierta de nori"],
        },
        {
          title: "California Roll",
          prize: "4.500",
          details: ["Cubierta de sésamo"],
        },
        {
          title: "California Green Roll",
          prize: "4.500",
          details: ["Cubierta de ciboulette"],
        },
        {
          title: "Snow Roll",
          prize: "4.800",
          details: ["Cubierta de queso crema"],
        },
        {
          title: "Super Snow Roll",
          prize: "5.100",
          details: ["Agrega: Merquen, Ciboulette, Sésamo, Maní ó Nuez"],
        },

        {
          title: "Avocado Roll",
          prize: "5.200",
          details: ["Cubierta de palta"],
        },
         {
          title: "Serrano Roll",
          prize: "5.400",
          details: ["Cubierta de Jamón Serrano"],
        },
        {
          title: "Sake Roll",
          prize: "5.500",
          details: ["Cubierta de salmón"],
        },
        {
          title: "Rainbow Roll",
          prize: "5.700",
          details: ["Cubierta de Palta y Salmón"],
        },
        {
          title: "Spicy Roll ",
          prize: "6.300",
          details: ["Cubierta de salmón aderezado con picante y especias"],
        },
        {
          title: "Ceviche Roll ",
          prize: "6.300",
          details: ["Cubierta de ceviche"],
        },
        // {
        //   title: 'Mango Roll',
        //   prize: '4.200',
        //   details: ['Cubierta Mango con salsa de arándano y vino tinto']
        // },
        {
          title: "Maguro Roll",
          prize: "6.200",
          details: ["Cubierta de atún rojo"],
        },
        {
          title: "Masago Roll",
          prize: "6.000",
          details: ["Cubierta de Huevas de Pez Capelán"],
        },
      ],
      arma_tu_roll_fritos: [
        {
          title: "Tempura Roll ",
          prize: "5.100",
          details: ["Batido Japonés"],
        },
        {
          title: "Panko Roll ",
          prize: "5.300",
          details: ["Pan rallado Japonés"],
        },
        {
          title: "Tori Panko Roll ",
          prize: "5.700",
          details: ["Pollo apanado"],
        },
        {
          title: "Sake Panko Roll ",
          prize: "6.000",
          details: ["Salmón apanado"],
        },
        {
          title: "Serrano Panko Roll",
          prize: "6.100",
          details: ["Jamón serrano apanado"],
        },
        {
          title: "Res Panko Roll",
          prize: "6.300",
          details: ["Carne apanada"],
        },
        // {
        //   title: 'Tempura en Piedra ',
        //   prize: '4.400',
        //   details: ['Roll aderezado con salsa Chancho en piedra']
        // },
      ],
      roll_sin_arroz: [
        {
          title: "Sake Grill Roll",
          prize: "6.000",
          details: ["Cubierta salmón grillado con salsa agridulce y almendras"],
        },
        {
          title: "Fresh Roll",
          prize: "6.000",
          details: ["Cubierta de Palta con salsa de ajo con ciboulette"],
        },
        {
          title: "Golden Roll",
          prize: "6.000",
          details: ["Cubierta de panko con salsa de Soya o agridulce"],
        },
      ],
      handrolls: [
        {
          title: "Handroll de pollo",
          prize: "3.500",
          details: ["Pollo, Queso Crema y Pimentón"],
        },
           {
          title: "Handroll de Camarón",
          prize: "4.000",
          details: ["Camarón, Queso Crema y Cebollín"],
        },
        // {
        //   title: "Handroll de Salmón",
        //   prize: "3.000",
        //   details: ["Salmón, Queso Crema y Champiñón"],
        // },
        {
          title: "Handroll de pollo/palta",
          prize: "4.000",
          details: ["Pollo, Queso Crema y Palta"],
        },
      ],
      coberturas_exclusivas: [
        {
          title: "Bacon Roll",
          prize: "6.500",
          details: [
            "Cubierta de tocino grillado con salsa tonkatsu relleno de queso mantecoso, palta y pollo teriyaki",
          ],
        },
        {
          title: "Ebi Cesar Roll",
          prize: "6.900",
          details: [
            "Cubierta de camarón con salsa cesar relleno de pimentón, pepino y queso crema",
          ],
        },
        {
          title: "Obako Tempura Roll",
          prize: "6.000",
          details: [
            "Cubierta de plátano tempura con salsa de vino relleno de mango, palta y queso crema",
          ],
        },
        // {
        //   title: "Ichigo Roll",
        //   prize: "6.000",
        //   details: [
        //     "Cubierta de frutilla con salsa de chocolate relleno de camarón panko, cebollín y queso crema",
        //   ],
        // },
        {
          title: "Res Grill Roll",
          prize: "6.900",
          details: [
            "Cubierta de carne grillada con queso fundido y salsa Niku relleno de palmitos, cebollín y palta",
          ],
        },
        {
          title: "Mango Roll",
          prize: "6.200",
          details: [
            "Cubierta de mango con salsa de vino tinto relleno de pollo panko, ciboulette y queso crema",
          ],
        },
        {
          title: "Maguro Sweet Roll",
          prize: "6.400",
          details: [
            "Cubierta de atún rojo con salsa maracuyá y maní, relleno de ika furai, cebollín y queso crema",
          ],
        },
        {
          title: "Coco Furai Roll",
          prize: "6.800",
          details: [
            "Cubierta mixta de coco y panko con salsa Niku relleno de carne, queso mantecoso y camarón",
          ],
        },
      ],
      gohan_y_ramen: [
        {
          title: "Gohan Bowl teri",
          prize: "6.500",
          details: [
            "Arroz de sushi, pollo teriyaki, cebollín, palta, sésamo, repollo y queso crema.",
          ],
        },
        {
          title: "Gohan Bowl sake",
          prize: "7.000",
          details: [
            "Arroz de sushi, salmón fresco, cebollín, palta, sésamo, repollo y queso crema.",
          ],
        },
        {
          title: "Gohan Bowl ebi teri",
          prize: "7.500",
          details: [
            "Arroz de sushi, pollo teriyaki, camarón tempura, cebollín, palta, sésamo, repollo y queso crema.",
          ],
        },
        // {
        //   title: 'Gran Yakisoba',
        //   prize: '6.990',
        //   details: ['Exquisita combinación de camarónes y pollo salteados, en cama de cebolla morada, zanahoria y cebollín acompañados de fideos de porotos y salsa de soya']
        // },
        // {
        //   title: 'Yakisoba sake',
        //   prize: '6.990',
        //   details: ['Exquisita combinación de camarónes y salmón salteado, en cama de cebolla morada, zanahoria y cebollín acompañados de fideos de porotos y salsa de soya']
        // },
        // {
        //   title: 'Yakimeshi',
        //   prize: '6.000',
        //   details: ['Pollo y camarónes salteados en cama de cebolla morada, zanahoria y cebollín, Acompañados con arroz gohan y salsa de soya']
        // },
        // {
        //   title: "Shōyu Ramen",
        //   prize: "9.000",
        //   details: [
        //     "Caldo a base de pollo y cerdo, con carne de cerdo, fideos, huevo, cebollín, champiñón shitake y nori.",
        //   ],
        // },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      let hash = window.location.hash;
      if (hash) {
        hash = hash.replace("#", "");
        console.log(this.$refs);
        setTimeout(() => {
          this.$refs[hash].scrollIntoView({ behavior: "smooth" });
        }, 1500);
      }
    });
  },
};
</script>


<style scoped>
.opciones .red {
  font-weight: bold;
  color: rgb(249, 0, 0);
}
h1.text-center {
  margin-top: 30px;
  margin-bottom: 30px;
}
h1.text-center::after {
  content: " ";
  border-bottom: 3px solid;
  padding: 8px;
  margin-bottom: 30px;
  display: block;
  border-color: rgb(249, 0, 0);
  width: 50%;
  margin: 0 auto;
}
h2 {
  margin: 20px 0;
  font-family: Bellefair;
  font-weight: bold;
}
.container {
  margin: 30px auto;
}
h1 {
  font-family: Bellefair;
  font-size: 50px;
}
.menu_title_wrap {
  padding: 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.menu_title {
  font-family: Bellefair;
  font-size: 24px;
}
.menu_title:after {
  content: "";
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  position: absolute;
  bottom: 4px;
  margin: 0 -100% 0 10px;
  border-bottom: 1px dotted;
  border-color: rgba(90, 90, 90, 0.3);
}
.menu-detail {
  font-family: "Source Sans Pro";
  font-size: 17px;
  line-height: 24px;
  font-weight: normal;
  font-style: normal;
}
.cmsmasters_menu_item {
  padding: 10px 10px;
  margin: 0 0 25px;
}
.cmsmasters_menu_item .menu_title_wrap {
  padding: 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.cmsmasters_menu_item .cmsmasters_menu_price {
  font-size: 16px;
  line-height: 24px;
}
.cmsmasters_menu_item .cmsmasters_menu_best_feature {
  padding: 5px 7px 4px;
  margin: 3px 0 0 20px;
  letter-spacing: 0.8px;
  line-height: 1;
  float: right;
  background-color: #f42643;
  color: #ffffff;
  font-size: 10px;
  font-family: "Montserrat", Arial, Helvetica, "Nimbus Sans L", sans-serif;
}
.cmsmasters_menu_item .menu_feature_list_wrap {
  overflow: hidden;
}
.cmsmasters_menu_item .menu_feature_list {
  padding: 0;
  margin: 0 0 0 -19px;
}
.cmsmasters_menu_item .menu_feature_list li {
  position: relative;
  padding: 0 0 0 20px;
  margin-top: 0px;
  display: block;
}
.cmsmasters_menu_item .menu_feature_list li::before {
  content: "- ";
}
.cmsmasters_menu_item .menu_title {
  margin: 0 10px 0 0;
  position: relative;
  width: 100%;
  overflow: hidden;
}
</style>